import React from "react";

function Gujaraticalender() {
  return <div>Gujaraticalender</div>;
}

export default Gujaraticalender;
